import { gql } from "@apollo/client";
import { values } from "./helper";
import dayjs from "@/lib/day";

export const typeDef = gql`
  type Link {
    id: ID!
    title: String
    url: String
    description: String
    targetBlank: Boolean
    date: String
    startAt: String
    endAt: String
    values: JSONObject
  }
`;

export const resolvers = {
  Link: {
    id: (link) => link?.id || link?.link_id,
    targetBlank: (link) => values(link, "target_blank"),
    date: (link) => {
      const date = dayjs(link.validity_start_at);
      if (date.isValid()) {
        return date.format("YYYY/M/D");
      } else {
        return null;
      }
    },
    startAt: (link) => link.validity_start_at,
    endAt: (link) => link.validity_end_at,
  },
};
